import request from '@/util/request'


/**
 * 产品异常
 */
export const faultList = (params) => {
    return request({
        url: `/api/v1/factory/fault/list`,
        method: 'get',
        params
    })
}
export const faultUnion = (name) => {
    return request({
        url: `/api/v1/factory/fault/union?name=${name}`,
        method: 'get'
    })
}

/**
 * 产品异常新增
 * @param data
 */
export const faultCreate = (data) => {
    return request({
        url: `/api/v1/factory/fault/create`,
        method: 'POST',
        data,
    })
}

/**
 * 产品异常协议更新
 * @param data
 */
export const faultUpdate = (data) => {
    return request({
        url: `/api/v1/factory/fault/update`,
        method: 'POST',
        data,
    })
}


/**
 * 产品异常协议更新
 * @param data
 */
export const faultDelete = (uuid) => {
    return request({
        url: `/api/v1/factory/fault/delete?uuid=${uuid}`,
        method: 'get',
    })
}


export function faultAlarmUnion(data) {
    return request({
        url: '/api/v1/factory/fault/data/union',
        method: 'get',
        params: data
    })
}


export function faultAlarmList(data) {
    return request({
        url: '/api/v1/factory/fault/dataList',
        method: 'get',
        params: data
    })
}
